import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { PageHeader, LoadingState, ErrorState } from "@/components/common";
import { BookSummary } from "@/components/capital/BookSummary";
import { AllocationPanel } from "@/components/capital/AllocationPanel";
import { PolicyEditor } from "@/components/capital/PolicyEditor";
import { PieChart } from "lucide-react";

const TABS = [["real", "Real capital (INR)"], ["paper_inr", "Sharekhan paper (INR)"], ["paper_usdt", "Binance paper (USDT)"]];

export default function CapitalAnalytics() {
  const [book, setBook] = useState("paper_usdt");
  const r = useQuery({ queryKey: ["cap-report", book], queryFn: async () => (await api.get(`/capital/report/${book}`)).data });
  return (
    <div className="space-y-6" data-testid="capital-page">
      <PageHeader title="Capital Analytics" subtitle="Separate books · flows never counted as P&L · rebalancing is paper-only" icon={PieChart} demo={false} testId="capital-header" />
      <div className="flex flex-wrap gap-2" data-testid="capital-tabs">
        {TABS.map(([k, l]) => (
          <button key={k} data-testid={`capital-tab-${k}`} onClick={() => setBook(k)}
            className={`rounded-md px-3 py-1.5 text-xs border transition-colors ${book === k ? "border-sky-500 text-sky-300 bg-sky-500/10" : "border-[var(--border-subtle)] text-slate-400 hover:text-slate-200"}`}>{l}</button>))}
      </div>
      {r.isLoading && <LoadingState label="Loading book..." />}
      {r.isError && <ErrorState label="Book unavailable (market data may be down)" onRetry={r.refetch} />}
      {r.data && <BookSummary r={r.data} />}
      {book !== "real" && <AllocationPanel key={`a-${book}`} book={book} />}
      {book !== "real" && <PolicyEditor key={`p-${book}`} book={book} />}
    </div>
  );
}
